import { BrandProvider } from '@grupoboticario/barril-del-chavo'
import { useMemo } from 'react'
import { categoriesByBrand } from 'src/components/molecules/CategoryList/CategoryList.constants'
import { usePromptDelivery } from '../usePromptDelivery'

const CURRENT_CATEGORY_LIST = categoriesByBrand[BrandProvider.getBrand()] || []

export const useCategoryList = () => {
  const { data: promptDeliveryProducts, isLoading } = usePromptDelivery()
  const categoryList = useMemo(() => {
    if (isLoading) {
      return []
    }

    const hasPromptDelivery = promptDeliveryProducts?.length > 0
    if (hasPromptDelivery) {
      return CURRENT_CATEGORY_LIST
    }

    return CURRENT_CATEGORY_LIST.filter(
      (category) => !category.title.toLowerCase().includes('pronta entrega'),
    )
  }, [promptDeliveryProducts, isLoading])

  return { categoryList, isLoading }
}
